import styled from 'styled-components';

export const Barra = styled.div`
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 12px;
  margin-bottom: 16px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 10px;
  background-color: ${({ theme }) => theme.cardBackground};
  box-shadow: 0 1px 3px ${({ theme }) => theme.shadowColor};
`;
